<template>
  <div class="tabbar-cartoon">
    <div class="tab-item" @click="$emit('input', index)" :class="{ active: value === index }" v-for="(item, index) in list" :key="index">
      <span>{{item.title}}</span>
      <img :src="TabBottom" class="bottom-icon" />
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    computed: {
      ...SetImage(['TabBottom'])
    },
    props: {
      value: null,
      list: null
    }
  }
</script>

<style lang="less" scoped>
  .tabbar-cartoon {
    display: flex;
    .tab-item {
      flex: 1;
      .flex-ccc();
      .fz(.3rem);
      .c(#666);
      &.active {
        span {
          transform: scale(1.3, 1.3);
          .c(#00b0f4);
          font-weight: bold;
        }
        .bottom-icon {
          opacity: 1;
        }
      }
      .bottom-icon {
        .w(1.14rem);
        .h(.22rem);
        .mt(.18rem);
        opacity: 0;
      }
    }
  }
</style>
